import { render, staticRenderFns } from "./institutionList.vue?vue&type=template&id=2bd40e7a&scoped=true"
import script from "./institutionList.vue?vue&type=script&lang=js"
export * from "./institutionList.vue?vue&type=script&lang=js"
import style0 from "./institutionList.vue?vue&type=style&index=0&id=2bd40e7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd40e7a",
  null
  
)

export default component.exports